export default __webpack_public_path__ + "static/media/trawa.e45addd1.svg";